import React,{ useState} from "react";
import Conversation from "./Conversation";
import ConversationHeader from "./ConversationHeader.jsx";
import phone from '../utils/phone-override.js'
import {Box} from "@mui/material";
import AgentsHeader from "./AgentsHeader.jsx";
import AgentsList from "./AgentsList.jsx";
import whatsappDoodle from "../assets/whatsappdoodle.jpeg";


export default function Widget({widgetInfo}) {
  const enabledAgents = widgetInfo.agents.filter(agent => agent.enabled);
  const [viewAgents,setViewAgents]=useState(false)
  const [message, setMessage] = useState(widgetInfo.widgetConfig?.messageStarterText??"");

  const handleSendMessage = (redirectNumber="",forward=true) => {
    try{
      const phoneNumber=phone(redirectNumber)
      if(phoneNumber.isValid){
        const sanitizedNumber = phoneNumber.phoneNumber.slice(1);
        const url = forward && message ? `https://api.whatsapp.com/send/?phone=${sanitizedNumber}&text=${message}&type=phone_number` : `https://api.whatsapp.com/send/?phone=${sanitizedNumber}&text&type=phone_number`;
        window.open(url);
      }
    }
    catch(error){
      console.log(error)
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        borderRadius: "15px 15px 15px 15px",
        overflowX: "hidden",
        overflowY: "auto",
        scrollbarWidth: "none",
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": {
          width: "0.4em",
        },
        "&::-webkit-scrollbar-track": {
          background: "transparent",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "transparent",
        },
      }}
    >
      {viewAgents ?(
        <React.Fragment>
          <AgentsHeader setViewAgents={setViewAgents}/>
          <AgentsList enabledAgents={enabledAgents} handleSendMessage={handleSendMessage}/>
        </React.Fragment>
      ):(
        <Box 
          sx={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            background: '#FFFFFF',
            flexGrow:1,
            backgroundImage: `url(${whatsappDoodle})`,
            backgroundRepeat: "repeat", 
            backgroundSize: "400px",
          }}
        >
          <ConversationHeader widgetConfig={widgetInfo.widgetConfig} />
          <Conversation widgetConfig={widgetInfo.widgetConfig} agentsEnabled={widgetInfo.agentsEnabled} enabledAgents={enabledAgents} setViewAgents={setViewAgents} message={message} setMessage={setMessage} handleSendMessage={handleSendMessage}/>
        </Box>
      )}
    </Box>
  );
}
